import { selectTotalTrees } from '../../../../selectors';

const makeSelectTotalTrees = (): typeof selectTotalTrees => selectTotalTrees;

export { makeSelectTotalTrees };
